import { BaseApi } from "./baseApi";
import { PumpType } from "../dtos/pumpType";

export class PumpTypeApi extends BaseApi<PumpType> {
  constructor(baseUri: string, enqueueSnackbar?: any, logout?: () => void) {
    super(baseUri, "pumpType", logout, enqueueSnackbar);
  }
}
